import { render, staticRenderFns } from "./certificateDataDoctorPra.vue?vue&type=template&id=55d1a6d9&scoped=true&"
import script from "./certificateDataDoctorPra.vue?vue&type=script&lang=js&"
export * from "./certificateDataDoctorPra.vue?vue&type=script&lang=js&"
import style0 from "./certificateDataDoctorPra.vue?vue&type=style&index=0&id=55d1a6d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d1a6d9",
  null
  
)

export default component.exports